<template>
  <div
    class="loading-screen v-center"
    v-if="!uk && !roi">
    <div class="loading-screen-text">
      <span class="text-yellow text-bold">Tysabri</span><br />
      <span class="text-green text-bold">Patient</span><br />
      <span class="text-blue">Alert<br />Card</span>
    </div>
    <div class="choose-country">
      <p>
        To access your patient alert card
        please select where you live:
      </p>
      <p>
        <button @click="selectCountry(1)">United Kingdom</button>
        <br />
        <button @click="selectCountry(2)">Republic of Ireland</button>
      </p>
    </div>
    <div class="loading-screen-footer">
      <img class="loading-screen-logo" src="../assets/tysabri_logo.png" alt="" />
      <p>
        Biogen-186460 V2<br />
        Date of preparation: October 2025
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen',
  data() {
    return {
      uk: false,
      roi: false,
    };
  },
  methods: {
    selectCountry(country) {
      if (country === 1) {
        this.uk = true;
        this.roi = false;
      } else {
        this.uk = false;
        this.roi = true;
      }
      this.$emit('selectCountry', country);
    },
  },
};
</script>

<style lang="scss">
.loading-screen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  background-color: #FFF;
  transition: opacity 1.5s ease-in-out;
  opacity: 1;
  overflow: scroll;
}
.is-loaded {
  opacity: 0;
  pointer-events: none;
}
.loading-screen-text {
  padding-top: 240px;
  text-transform: uppercase;
  font-size: 60px;
  width: 270px;
  margin: 0 auto;
  line-height: 1;
}
.choose-country {
  width: 270px;
  margin: 10px auto 100px auto;
  text-align: center;
  padding-top: 20px;
  font-weight: bold;
}
.choose-country p {
  font-size: 15px;
}
.choose-country button {
  background-color: #7a97bd;
  border-radius: 10px;
  color: white;
  font-weight: bold;
  padding: 10px;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
  cursor: pointer;
  &:hover {
    background-color: darken(#7a97bd, 20%);
  }
}
.loading-screen-footer {
  text-align: center;
  pointer-events: none;
}
.loading-screen-logo {
  display: inline-block;
  margin-bottom: 30px;
  max-width: 140px;
}
@media all and (min-width: 40em) {
  .loading-screen-text {
    font-size: 80px;
    width: 360px;
    padding-top: 110px;
  }
  .loading-screen-logo {
    max-width: 200px;
  }
}
</style>
